/* eslint-disable no-global-assign, no-undef */

import { getAssetBaseByPageName } from '@/multi/pageRoutes'

export function setWebpackPublicPath(pageName) {
  __webpack_public_path__ = getAssetBaseByPageName(pageName)
}
